const mediaItems = [
  {
    title: '星际迷航：新纪元',
    tag: '科幻巨制',
    quality: '4K蓝光',
    rating: '9.2',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%20style%20with%20astronaut%20floating%20in%20deep%20space%2C%20giant%20spiral%20galaxy%20in%20background%2C%20dramatic%20golden%20and%20blue%20nebula%20lighting%2C%20cinematic%20composition%2C%20dark%20atmospheric%20tones%2C%20film%20grain%20texture&width=600&height=840&seq=media-01&orientation=portrait',
  },
  {
    title: '长安十二时辰',
    tag: '古装悬疑',
    quality: '1080P',
    rating: '8.8',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20mysterious%20atmosphere%2C%20warm%20amber%20lighting%2C%20period%20drama%20aesthetic%2C%20cinematic%20composition%20with%20deep%20shadows%2C%20rich%20historical%20texture&width=600&height=840&seq=media-02&orientation=portrait',
  },
  {
    title: '深海迷城',
    tag: '冒险大片',
    quality: '4K超清',
    rating: '8.5',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20underwater%20ancient%20ruins%20with%20bioluminescent%20creatures%2C%20deep%20ocean%20exploration%20scene%2C%20dark%20blue%20and%20teal%20tones%2C%20dramatic%20light%20rays%20from%20surface%2C%20cinematic%20adventure%20movie%20aesthetic%2C%20atmospheric%20underwater%20photography&width=600&height=840&seq=media-03&orientation=portrait',
  },
  {
    title: '极限追击',
    tag: '动作犯罪',
    quality: '蓝光原盘',
    rating: '9.0',
    img: 'https://readdy.ai/api/search-image?query=Intense%20urban%20night%20chase%20scene%20with%20motorcycle%20on%20rain-slicked%20city%20streets%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20dramatic%20cinematic%20lighting%20with%20red%20and%20amber%20tones%2C%20action%20thriller%20movie%20aesthetic%2C%20high%20contrast%20composition&width=600&height=840&seq=media-04&orientation=portrait',
  },
  {
    title: '月光变奏曲',
    tag: '浪漫爱情',
    quality: '4K',
    rating: '8.3',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20moonlit%20night%20scene%20with%20couple%20silhouette%20against%20city%20skyline%2C%20soft%20warm%20golden%20moon%20glow%2C%20gentle%20atmospheric%20lighting%2C%20dreamy%20cinematic%20aesthetic%2C%20Korean%20drama%20style%20composition%2C%20tender%20mood%20with%20cherry%20blossom%20petals&width=600&height=840&seq=media-05&orientation=portrait',
  },
];

const cardItems = [
  {
    title: '本周新片速递：五部不可错过的院线大片',
    desc: '从好莱坞巨制到国产口碑佳作，本周上线的五部新片涵盖科幻、悬疑、喜剧等多种类型，4K蓝光画质带给您身临其境的观影体验。',
    tag: '新片推荐',
    date: '8月1日',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20clapperboard%20on%20dark%20wooden%20surface%2C%20warm%20golden%20spotlight%2C%20vintage%20cinema%20aesthetic%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20editorial%20photography%20style%2C%20rich%20texture%20and%20atmosphere&width=640&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '暑期档最强片单：全家一起看的合家欢电影精选',
    desc: '暑假过半，我们精心整理了适合全家一起观看的高分影片合集，从动画到真人电影，每一部都经过画质优化，支持4K超清播放。',
    tag: '观影指南',
    date: '7月30日',
    img: 'https://readdy.ai/api/search-image?query=Cozy%20family%20living%20room%20with%20large%20TV%20screen%20displaying%20colorful%20animation%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%20with%20blankets%2C%20cinematic%20home%20theater%20atmosphere%2C%20golden%20hour%20light%20through%20window&width=640&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '悬疑迷必看：近年评分最高的十部烧脑神作',
    desc: '精心盘点近年豆瓣评分8.5以上的悬疑佳作，每一部都考验智商、反转不断。90影视已全部收录蓝光版本，细节一览无余。',
    tag: '精选合集',
    date: '7月28日',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20desk%20with%20magnifying%20glass%20and%20old%20photographs%2C%20film%20noir%20aesthetic%2C%20dramatic%20shadow%20play%2C%20vintage%20office%20setting%2C%20warm%20desk%20lamp%20lighting%2C%20atmospheric%20crime%20scene%20vibe&width=640&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '4K修复经典：那些年我们追过的港片回来了',
    desc: '多部经典香港电影已完成4K数字修复，画质焕然一新。90影视第一时间上线修复版本，带您重温黄金年代的银幕记忆。',
    tag: '经典回顾',
    date: '7月25日',
    img: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20street%20scene%20with%20neon%20signs%20and%20wet%20pavement%2C%20cinematic%20night%20photography%2C%20vibrant%20red%20and%20gold%20neon%20glow%2C%20atmospheric%20urban%20Chinese%20cityscape%2C%20film%20noir%20style%20composition&width=640&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '国产剧崛起：2026上半年口碑爆棚剧集盘点',
    desc: '从古装正剧到现代职场，国产剧集质量持续攀升。我们整理了上半年豆瓣8分以上的国产好剧，蓝光画质全收录。',
    tag: '剧集推荐',
    date: '7月22日',
    img: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20film%20set%20with%20director%20chair%20and%20professional%20camera%20equipment%2C%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20cinematic%20atmosphere%2C%20clean%20minimalist%20composition%2C%20contemporary%20drama%20aesthetic&width=640&height=400&seq=card-05&orientation=landscape',
  },
  {
    title: '纪录片推荐：开阔眼界的十部高分自然纪录片',
    desc: '足不出户看世界！精选十部画面精美的高分自然纪录片，4K超清画质还原大自然的壮丽奇观，适合全家观看。',
    tag: '纪录片',
    date: '7月20日',
    img: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20vast%20mountain%20range%20with%20golden%20sunrise%20light%2C%20pristine%20nature%20landscape%2C%20documentary%20film%20aesthetic%2C%20breathtaking%20cinematic%20photography%2C%20warm%20atmospheric%20tones%2C%20dramatic%20clouds%20and%20fog&width=640&height=400&seq=card-06&orientation=landscape',
  },
];

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="text-xs font-label text-accent-400 uppercase tracking-wider">正在热播</span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">精选推荐</h2>
          </div>
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="text-sm text-primary-400 hover:text-primary-300 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer font-label"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {mediaItems.map((item, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="relative rounded-lg overflow-hidden aspect-[2/3] bg-background-100/50 border border-background-200/40">
                <img
                  src={item.img}
                  alt={`90影视 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i < 4 ? undefined : 'lazy'}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 text-[10px] font-label bg-primary-500 text-background-50 rounded">{item.quality}</span>
                </div>
                <div className="absolute bottom-3 left-3 right-3">
                  <p className="text-xs text-foreground-400 mb-1 font-label">{item.tag}</p>
                  <h3 className="text-sm text-foreground-950 font-label font-medium leading-tight">{item.title}</h3>
                  <div className="flex items-center gap-1 mt-1">
                    <i className="ri-star-fill text-[10px] text-primary-400"></i>
                    <span className="text-xs text-primary-400 font-label">{item.rating}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100/40">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="text-xs font-label text-primary-400 uppercase tracking-wider">影视资讯</span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1">最新上架</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div key={i} className="group cursor-pointer bg-background-50 rounded-lg border border-background-200/40 overflow-hidden hover:border-background-300/60 transition-colors">
              <div className="relative overflow-hidden aspect-[16/10] bg-background-100">
                <img
                  src={item.img}
                  alt={`90影视 - ${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={i < 3 ? undefined : 'lazy'}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-label bg-accent-500 text-background-50 rounded">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-xs text-foreground-500 font-label">{item.date}</span>
                </div>
                <h3 className="text-sm text-foreground-950 font-label font-medium leading-snug mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-100/60 border border-background-200/40 rounded-lg p-6 md:p-10 flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-1 text-center md:text-left">
            <span className="text-xs font-label text-accent-400 uppercase tracking-wider">联系我们</span>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mt-1 mb-3">投稿与合作</h2>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              如果您有优质的影视资源、原创影评或希望与90影视开展商务合作，欢迎通过以下方式联系我们。
              我们重视每一位合作伙伴，期待与您共同打造更好的观影平台。
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-md border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-colors">
              <i className="ri-mail-line text-xl text-primary-400"></i>
              <div>
                <p className="text-xs text-foreground-500 font-label">投稿邮箱</p>
                <p className="text-sm text-foreground-800 font-label">contact@90ys.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-md border border-background-200/60 cursor-pointer hover:border-primary-500/30 transition-colors">
              <i className="ri-wechat-line text-xl text-accent-400"></i>
              <div>
                <p className="text-xs text-foreground-500 font-label">官方微信</p>
                <p className="text-sm text-foreground-800 font-label">90影视官方号</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default function MediaCardsGroup() {
  return (
    <>
      <MediaSection />
      <CardsSection />
      <ContactSection />
    </>
  );
}